'use strict';

exports.__esModule = true;

var _react = require('react');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// NOTE: `onPaste` should return an array of files that were acceptedFiles
//
// const Image = ({ src }) => <img src={image} alt={`Pasted: ${image}`} />
//
// <PasteContainer
//    onPaste={files => this.method(files)}
//    errorHandler={err => console.error(err)}
// >
//   {images => images.map((image, i) => <Image src={image} key={i} />)}
// </PasteContainer>

var Gluejar = function (_Component) {
  _inherits(Gluejar, _Component);

  function Gluejar() {
    var _temp, _this, _ret;

    _classCallCheck(this, Gluejar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      items: []
    }, _this.getContainer = function () {
      return _this.props.container ? _this.props.container : window;
    }, _this.isValidFormat = function (fileType) {
      return _this.props.acceptedFiles.includes(fileType);
    }, _this.pasteHandler = function (e) {
      return _this.checkPasted(e, _this.pushImage);
    }, _this.transformImages = function (items, cb) {
      // NOTE: This needs to be a for loop, it's a list like object
      if (window.Clipboard || window.ClipboardEvent) {
        for (var i = 0; i < items.length; i++) {
          if (_this.isValidFormat(items[i].type) !== false) {
            // NOTE: returns a Blob instance
            var blob = items[i].getAsFile() || items[i].webkitGetAsEntry();

            // NOTE: This could probably call `new URL()`
            var URL = window.URL || window.webkitURL;

            if (blob) {
              // We shouldn't fire the callback if we can't create `new Blob()`
              var src = URL.createObjectURL(blob);

              cb(src);
            }
          } else {
            _this.props.errorHandler('Sorry, that\'s not a format we support');
          }
        }
      }
    }, _this.checkPasted = function (e, cb) {
      e.clipboardData && e.clipboardData.items.length > 0 ? _this.transformImages(e.clipboardData.items, cb) : _this.props.errorHandler('Sorry, to bother you but there was no image pasted.');
    }, _this.pushImage = function (source) {
      return _this.setState(function (_ref) {
        var items = _ref.items;
        return { items: [].concat(items, [source]) };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Gluejar.prototype.componentDidMount = function componentDidMount() {
    var elm = this.getContainer();
    elm.addEventListener('paste', this.pasteHandler);
  };

  Gluejar.prototype.componentDidUpdate = function componentDidUpdate() {
    this.props.onPaste(this.state.items);
  };

  Gluejar.prototype.componentWillUnmount = function componentWillUnmount() {
    var elm = this.getContainer();
    elm.removeEventListener('paste', this.pasteHandler);
  };

  Gluejar.prototype.render = function render() {
    var items = this.state.items;


    return this.props.children(items);
  };

  return Gluejar;
}(_react.Component);

Gluejar.displayName = 'Gluejar';
Gluejar.defaultProps = {
  onPaste: function onPaste() {
    return null;
  },
  errorHandler: function errorHandler() {
    return null;
  },
  acceptedFiles: ['image/gif', 'image/png', 'image/jpeg', 'image/bmp']
};
exports.default = Gluejar;